import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Image, InputGroup, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ISearchStrings, SearchStrings } from "../../../business/core/globalization";
import "../../impl/screens/assets/css/header.css";
import { SearchControllerImpl } from "../impl";
import { SearchData } from "../interfaces";

export const SearchInputSmall: React.FC = () => {
    const strings: ISearchStrings = SearchStrings['PTBR'];
    const navigate = useNavigate();
    const [searchData, setSearchData] = useState<SearchData[]>([]);
    const [enteredTerm, setEnteredTerm] = useState("");
    const searchAreaRef = useRef(null);

    // Cria uma instância única do controller para evitar recriações desnecessárias
    const controllerRef = useRef(new SearchControllerImpl());

    // Atualiza o estado com o termo digitado
    const handleFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
        const searchWord = event.target.value;
        setEnteredTerm(searchWord);
    };

    // useEffect com debounce: aguarda 1 segundo sem digitação para realizar a pesquisa
    useEffect(() => {
        if (enteredTerm.length > 3) {
            const timer = setTimeout(async () => {
                try {
                    const dataResponse = await controllerRef.current.getSearch(enteredTerm);
                    setSearchData(dataResponse);
                } catch (error) {
                    console.error(error);
                }
            }, 1000);
            return () => clearTimeout(timer);
        } else {
            // Se o termo for vazio ou menor que 4 caracteres, limpa os resultados
            setSearchData([]);
        }
    }, [enteredTerm]);

    const handleItem = () => {
        setSearchData([]);
        let productName = enteredTerm.toLowerCase()
            .replace(/[^\w\s]/gi, '')
            .replace(/\s+/g, '_')
            .trim();
        productName = encodeURIComponent(productName);
        navigate(`/search/${productName}`, { state: { term: enteredTerm } });
    };

    return (
        <div ref={searchAreaRef} style={{ width: '100%' }} className="d-lg-none">
            <InputGroup>
                <Form.Control
                    placeholder={strings.placeholder}
                    aria-label={strings.placeholder}
                    aria-describedby="basic-addon2"
                    className="search-input-customize"
                    value={enteredTerm}
                    onChange={handleFilter}
                    list="suggestion"
                />
                <Button
                    variant="outline-secondary"
                    className="search-button-customize"
                    id="button-addon2"
                    onClick={handleItem}
                >
                    {strings.button}
                </Button>
                {enteredTerm !== "" && searchData.length > 0 ? (
                    <section
                        className="bg-white border border-top-0 p-3"
                        style={{ position: "absolute", width: "100%", marginTop: 51, zIndex: 2 }}
                        onClick={handleItem}
                    >
                        {searchData.map((item, index) => (
                            <Row key={index} className="search-autocomplete-item mb-1 py-2">
                                <Col xs={3} md={2}>
                                    <Image src={item.image} thumbnail />
                                </Col>
                                <Col xs={9} md={10}>
                                    {item.description}
                                </Col>
                            </Row>
                        ))}
                    </section>
                ) : null}
            </InputGroup>
        </div>
    );
};
